import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { FormGroup, Input, Label, ModalBody, ModalFooter } from "reactstrap";
import { object, string } from "yup";
import ToastHandler from "../../../components/Common/ToastHandler";
import Axios from "../../../lib/Axios";

const schema = object({
  lookingFor: string().required("Required"),
});

const JobForm = ({ data, setEditData, refetch }) => {
  const [toast, setToast] = useState(false);

  const [toastData, setToastData] = useState({
    title: "",
    message: "",
  });

  async function onSubmit(formData) {
    try {
      const dt = data
        ? {
            lookingFor:formData.lookingFor,
            lookingForId: data.lookingForId,
          }
        : {
            ...formData,
          };
      const result = data
        ? await Axios.post("/cms/cms-edit/looking-for", dt)
        : await Axios.post("/cms/cms-set/looking-for", dt);

      setToastData({
        message: "Submitted",
        title: "Success",
      });
      setToast(true);
      refetch();
    } catch (error) {
      if (error.status === 500) {
        setToastData({
          message: error.response.data.error.message,
          title: "Error",
        });
        setToast(true);
      } else if (error.status === 400) {
        setToastData({
          message: error.response.data.message,
          title: "Error",
        });
        setToast(true);
      }
    }
  }

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      lookingFor:  data?.lookingFor || ""
    },
    validationSchema: schema,
    onSubmit: onSubmit,
  });

  useEffect(() => {
    return () => {
      if (data) {
        setEditData(null);
      }
    };
  }, []);

  return (
    <>
      <form className="tablelist-form" onSubmit={formik.handleSubmit}>
        <ModalBody>
          <div className="mb-3">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom01">Looking For</Label>
              <Input
              placeholder="Looking For"
              type="text"
              id="lookingFor"
              name="lookingFor"
              value={formik.values.lookingFor}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur} // For better error handling
              className={`form-control ${
                formik.touched.lookingFor && formik.errors.lookingFor
                  ? "is-invalid"
                  : ""
              }`}
            />

              {formik.touched.lookingFor && formik.errors.lookingFor && (
                <div className="error">{formik.errors.lookingFor}</div>
              )}
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button
              disabled={formik.isSubmitting}
              type="submit"
              className="btn btn-success"
            >
              {formik.isSubmitting ? "Wait..." : "Submit"}
            </button>
          </div>
        </ModalFooter>
      </form>
      <ToastHandler
        open={toast}
        setOpen={setToast}
        duration={2000}
        message={toastData.message}
        title={toastData.title}
      />
    </>
  );
};

export default JobForm;
